class FloatingImageListingBlock {
	constructor() {
		const blocks = document.querySelectorAll('.floating-image-listing-block');

		for(let i = 0; i < blocks.length; i++) {
			if (i % 2 !== 0)
			blocks[i].classList.add('reverse')
		}
	}
}

export default FloatingImageListingBlock;
